import { Capacitor } from '@capacitor/core';
import { isVoipCallAvailable, VoipCall } from './voip-call.plugin';

// Дзвінок вбудованого телефону для «Недавніх» системного застосунку «Телефон»
export interface CallHistoryInfo {
  direction: 'incoming' | 'outgoing';
  number: string;
  name?: string;
  // id для CallKit: channelId вхідного дзвінка (якщо на нього відповіли із системного екрана, дзвінок уже в CallKit)
  id?: string;
}

export interface CallHistoryEntry extends CallHistoryInfo {
  id: string;
  startedAt: number;
  connectedAt?: number;
}

/**
 * iOS: «Недавні» показують лише дзвінки CallKit — тому кожну розмову застосунку ведемо як дзвінок CallKit
 * (з початку і до кінця, щоб збереглась тривалість). Android: у журнал викликів системи не пишемо —
 * WRITE_CALL_LOG Google Play дозволяє лише основному застосунку «Телефон» (розмови є в журналі дзвінків CRM).
 * У старих нативних збірках цих методів немає — помилки ігноруємо.
 */
export const CallHistory = {
  start(info: CallHistoryInfo): CallHistoryEntry {
    const entry: CallHistoryEntry = { ...info, id: info.id || `local-${Date.now()}-${Math.random().toString(36).slice(2)}`, startedAt: Date.now() };
    if (isIos()) {
      VoipCall.startCall({ callId: entry.id, number: entry.number, name: entry.name || '', incoming: entry.direction === 'incoming' }).catch(() => {});
    }
    return entry;
  },

  connected(entry: CallHistoryEntry): void {
    entry.connectedAt = Date.now();
    if (isIos()) VoipCall.reportConnected({ callId: entry.id }).catch(() => {});
  },

  end(entry: CallHistoryEntry): void {
    if (isIos()) VoipCall.endCall({ channelId: entry.id }).catch(() => {});
  }
};

function isIos(): boolean {
  return Capacitor.getPlatform() === 'ios' && isVoipCallAvailable();
}
